<template>
  <v-card flat striped exact max-width="370" max-height="500"  :to="link">
    <ImageCard
     
      :minHeight_c="300"
      :imageName="imgName"
      :alt="imgName"
      parentFolder="blogs"
    />
    <v-card-title class="text-start pl-0"> {{ title }} </v-card-title>
    <v-card-text class="text-start pl-0"> {{ desc }} </v-card-text>
    <v-card-actions class="pl-0">
      <v-btn text color="#C25F61"> LEARN MORE </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ImageCard from "@/components/global/ImageCard";
export default {
  components: {
    ImageCard,
  },
  props: {
    title: {
      type: String,
    },
    desc: {
      type: String,
    },
    imgName: {
      type: String,
    },
    link: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>